module.exports = __webpack_public_path__ + "img/GDQ-matcirkel_10.2df1b32d.gif";